import actionTypes from './actionTypes';
import getActionCreator from '../libs/getActionCreator';

export const setPostflopSituation = getActionCreator(actionTypes.SET_POSTFLOP_SITUATION);
export const setPostflopSimilar = getActionCreator(actionTypes.SET_POSTFLOP_SIMILAR);
export const setBoardSituation = getActionCreator(actionTypes.SET_BOARD_SITUATION);
export const setCombo = getActionCreator(actionTypes.SET_COMBO);
export const getCombo = getActionCreator(actionTypes.GET_COMBO);
export const getNextCombo = getActionCreator(actionTypes.GET_NEXT_COMBO);
export const getPostflopResultsStat = getActionCreator(actionTypes.GET_POSTFLOP_RESULTS_STAT);
export const setSimilarResponse = getActionCreator(actionTypes.SET_SIMILAR_RESPONSE);

export const setTableSize = (payload) => ({
  type: actionTypes.SET_TABLE_SIZE,
  payload,
});

export const setStackSize = (payload) => ({
  type: actionTypes.SET_STACK_SIZE,
  payload,
});

export const setPositionType = (payload) => ({
  type: actionTypes.SET_POSITION_TYPE,
  payload,
});

export const setPageMode = (payload) => ({
  type: actionTypes.SET_PAGE_MODE,
  payload,
});

export const setGameStarted = (payload) => ({
  type: actionTypes.SET_GAME_STARTED,
  payload,
});

export const setHighLow = (payload) => ({
  type: actionTypes.SET_HIGH_LOW,
  payload,
});

export const setPosition = (payload) => ({
  type: actionTypes.SET_POSITION,
  payload,
});

export const setResultsPositionType = (payload) => ({
  type: actionTypes.SET_RESULTS_POSITION_TYPE,
  payload,
});

export const setResultsPfrType = (payload) => ({
  type: actionTypes.SET_RESULTS_PFR_TYPE,
  payload,
});

export const setResultsPlayerPosition = (payload) => ({
  type: actionTypes.SET_RESULTS_PLAYER_POSITION,
  payload,
});

export const setResultsPosition = (payload) => ({
  type: actionTypes.SET_RESULTS_POSITION,
  payload,
});

export const setResultsPreviousAction = (payload) => ({
  type: actionTypes.SET_RESULTS_PREVIOUS_ACTION,
  payload,
});

export const setBoardSuit = (payload) => ({
  type: actionTypes.SET_BOARD_SUIT,
  payload,
});

export const setBoardType = (payload) => ({
  type: actionTypes.SET_BOARD_TYPE,
  payload,
});

export const setSelectedHighCard = (payload) => ({
  type: actionTypes.SET_SELECTED_HIGH_CARD,
  payload,
});

export const setSelectedHandType = (payload) => ({
  type: actionTypes.SET_SELECTED_HAND_TYPE,
  payload,
});

export const setSelectedBoard = (payload) => ({
  type: actionTypes.SET_SELECTED_BOARD,
  payload,
});

export const setSelectedCards = (payload) => ({
  type: actionTypes.SET_SELECTED_CARDS,
  payload,
});

export const setSearchValue = (payload) => ({
  type: actionTypes.SET_SEARCH_VALUE,
  payload,
});
